import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { ExposureConstants } from '../store/exposure.constants'
import { IExposureState } from '../store/exposure.types'
import { getExposureSelector } from '../selectors/getExposure.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveExposure() {
  const exposure: IExposureState = yield select(getExposureSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (!pcrID) {
    return
  }
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  const pcrDocUpdated: IPcr = {
    ...pcrDoc,
    exposure,
  }

  try {
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
  } catch (e) {
    yield put(throwPcrException(`saveExposure() error: ${e}`))
  }
}

export function* saveExposureSaga() {
  yield takeLatest(
    [
      ExposureConstants.SAVE_EXPOSURE,
      ExposureConstants.SET_EXPOSURE_LIST,
      ExposureConstants.SET_EXPOSED_TO,
      ExposureConstants.SET_SUSPECTED_EXPOSURE,
      ExposureConstants.SET_SUSPECTED_EXPOSURE_PNNV,
      ExposureConstants.SET_EXPOSURE_TYPE,
      ExposureConstants.SET_EXPOSURE_TYPE_PNNV,
      ExposureConstants.SET_EXPOSURE_STATE,
    ],
    performWithMutexHOG,
    saveExposure
  )
}
